import { useStrings } from "features/i18n/useStrings";

import { GuxButtonSlot, GuxModal } from "genesys-spark-components-react";
import strings from "./VisibilityConflictErrorBox.strings";

// values of this enum are the keys within the string file
export enum ErrorAction {
    MoveUp = "moveUp",
    MoveDown = "moveDown",
    Delete = "delete",
}

export function ErrorBox({
    errorMessages,
    clearSourceError,
}: {
    errorMessages: JSX.Element;
    clearSourceError?: () => void;
}) {
    const t = useStrings(strings);

    return (
        <>
            {errorMessages && (
                <div>
                    <GuxModal
                        open={errorMessages ? true : false}
                        trap-focus="true"
                        size="large"
                        onGuxdismiss={() => {
                            clearSourceError !== undefined &&
                                clearSourceError();
                        }}
                    >
                        <div slot="title" className="gux-heading-lg-bold">
                            {t.labels.formValidationErrors}
                        </div>
                        <div slot="content">
                            <ul>{errorMessages}</ul>
                        </div>
                        <div slot="start-align-buttons">
                            <GuxButtonSlot accent="primary">
                                <button
                                    type="button"
                                    onClick={() =>
                                        clearSourceError !== undefined &&
                                        clearSourceError()
                                    }
                                >
                                    {t.labels.cancel}
                                </button>
                            </GuxButtonSlot>
                        </div>
                    </GuxModal>
                </div>
            )}
        </>
    );
}
